export enum AvgConsentLevel {
    NECESSARY   = 'necessary',
    PREFERENCES = 'preferences',
    STATISTICS  = 'statistics',
    MARKETING   = 'marketing',
}

export function stringToAvgConsentLevel(value: string): AvgConsentLevel | null {
    return Object.values(AvgConsentLevel).includes(value as AvgConsentLevel)
        ? value as AvgConsentLevel
        : null;
}
